import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=c1ff50c4&scoped=true"
import script from "./ListCustomer.vue?vue&type=script&lang=js"
export * from "./ListCustomer.vue?vue&type=script&lang=js"
import style0 from "./ListCustomer.vue?vue&type=style&index=0&id=c1ff50c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ff50c4",
  null
  
)

export default component.exports